import { DataService } from "@/services/data";

export const feedingUrl = (campaignCode: string, path = "") => `/dialer/campaigns/${campaignCode}/feeding/${path}`;

/** Message of a refused request (`{detail}`), else `fallback`. */
export async function errorDetail(error: unknown, fallback: string): Promise<string> {
    const failure = error as { json?: { detail?: unknown }; response?: Response };
    if (typeof failure.json?.detail === "string") return failure.json.detail;
    const body = (await failure.response?.json?.().catch(() => null)) as { detail?: unknown } | null | undefined;
    return typeof body?.detail === "string" ? body.detail : fallback;
}

export const feedingClient = (campaignCode: string, path = "") => DataService.client.url(feedingUrl(campaignCode, path));
